import PropTypes from 'prop-types';
import React from 'react';
import { Spinner } from '../UI';

class SpinnerMessage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const { message } = this.props;

    return (
      <div style={{ textAlign: 'center' }}>
        <p className="app-status">{message}</p>
        <div id="spinnerBlock">
          <div className="app-spinner">
            <Spinner />
          </div>
        </div>
      </div>
    );
  }
}

SpinnerMessage.propTypes = {
  message: PropTypes.string,
};

SpinnerMessage.defaultProps = {
  message: '',
};

export default SpinnerMessage;
